import { Location, NavigateFunction } from "react-router-dom";

export type SiteReturnLabel =
    | "Back to Site List"
    | "Back to Site Selection"
    | "Back to Survey Selection"
    | "Back to Map"
    | "Back to Graph"
    | "Back to Rank Order";

type SiteNavigationOptions = {
    siteRef: string;
    type?: string;
    fromTab?: string;
    returnLabel?: SiteReturnLabel;
    returnTo?: string;
    replace?: boolean;
    extraParams?: Record<string, string | null | undefined>;
};

export const getCurrentRoute = (location: Pick<Location, "pathname" | "search" | "hash">) =>
    `${location.pathname}${location.search}${location.hash}`;

export const navigateToSite = (
    navigate: NavigateFunction,
    location: Pick<Location, "pathname" | "search" | "hash">,
    options: SiteNavigationOptions
) => {
    const params = new URLSearchParams();
    params.set("siteRef", options.siteRef);

    if (options.type) params.set("type", options.type);
    if (options.fromTab) params.set("fromTab", options.fromTab);
    if (options.returnTo ?? getCurrentRoute(location)) {
        params.set("returnTo", options.returnTo ?? getCurrentRoute(location));
    }
    if (options.returnLabel) params.set("returnLabel", options.returnLabel);

    Object.entries(options.extraParams ?? {}).forEach(([key, value]) => {
        if (value) params.set(key, value);
    });

    navigate(`/site?${params.toString()}`, { replace: options.replace });
};

export const getSiblingSiteUrl = (search: string, siteRef: string) => {
    const params = new URLSearchParams(search);
    params.set("siteRef", siteRef);
    return `/site?${params.toString()}`;
};

export const isInternalReturnTo = (returnTo: string) =>
    returnTo.startsWith("/") && !returnTo.startsWith("//");

export const getLegacySiteReturnLabel = (type: string, fromTab: string, origin: string) => {
    if (origin === "map") return "Back to Map";
    if (origin === "graph" || fromTab === "rankGraph") return "Back to Graph";
    if (type === "siteList") return "Back to Site List";
    if (type === "summaryFiltering" && fromTab === "siteSummary") return "Back to Site Selection";
    if (type === "summaryFiltering" && fromTab === "surveySummary") return "Back to Survey Selection";
    if (type === "rankorder") return "Back to Rank Order";
    return "Back to Search";
};
